module.exports = {
  "country": "UA",
  "artist": "Ziferblat",
  "song": "Birds of Pray",
  "year": "2025",
  "place": "9",
  "spotify": "5lmoGiZquqsW9sNxJQGRHn"
};